import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import listItems from 'flarum/common/helpers/listItems';
import Link from 'flarum/common/components/Link';
import PostUser from 'flarum/forum/components/PostUser';
import avatar from 'flarum/common/helpers/avatar';
import sortTags from 'flarum/tags/common/utils/sortTags';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';

export default function () {
  override(DiscussionPage.prototype, 'hero', function () {
    const bgBannerImgUrl = app.forum.attribute('baseUrl') + '/assets/images/banner_linear_200_f.png';
    const discussion = this.discussion;
    const routeName = app.current.get('routeName');
    const tags = sortTags(discussion.tags() || []);
    let tagsOptions = tags.map((tag: any) => ({
      label: tag.name(),
      value: tag.id(),
      slug: tag.slug(),
      color: tag.color(),
      isChild: tag.isChild(),
      parent_id: tag.parent() ? tag.parent().id() : '',
    }));
    const user = discussion.user();
    return (
      <div className="custom-DiscussionPage-hero" style={{ background: `url(${bgBannerImgUrl}) no-repeat center top` }}>
        <div className="container">
          <div class="custom-DiscussionListItem-title">
            <ul className="DiscussionListItem-badges badges">{listItems(discussion.badges().toArray())}</ul>
            <h2 className="DiscussionListItem-title">{discussion.title()}</h2>
          </div>
          {tagsOptions.length ? (
            <ul className="DiscussionListItem-tags">
              {tagsOptions.map((tag: any) => {
                // 检查是否为二级分类（有parent_id）
                const isChild = tag.isChild;
                // 如果是二级分类，找到父级分类的颜色
                const parentTag = isChild ? tagsOptions.find((t) => t.value === tag.parent_id) : null;
                const parentColor = parentTag ? parentTag.color : null;

                return (
                  <Link href={app.route('tag', { tags: tag.slug })} key={tag.value}>
                    {isChild && parentColor ? (
                      <span
                        className="tag-icon tag-icon-child"
                        style={{
                          background: `linear-gradient(to right, ${parentColor} 50%, ${tag.color} 50%)`,
                        }}
                      ></span>
                    ) : (
                      <span className="tag-icon" style={{ backgroundColor: tag.color }}></span>
                    )}
                    <span className="DiscussionListItem-tag">{tag.label}</span>
                  </Link>
                );
              })}
            </ul>
          ) : null}
          {routeName === 'byobuPrivate' ? <div>{user.username()}</div> : null}
        </div>
      </div>
    );
  });

  // override(PostUser.prototype, 'hideCard', function () {
  //   // 调试用户头像 卡片
  // });
}
